<template>
  <v-menu location="bottom" class="text-center">
    <template v-slot:activator="{ props }">
      <v-btn
        type="text"
        v-bind="props"
        class="text-h6 text-uppercase text-white px-sm-6 mr-1"
      >
        <v-avatar size="32" class="mr-3">
          <v-icon
            color="white"
            v-if="!avatar"
            size="34"
          >
            account_circle
          </v-icon>
          <v-img
            :src="!!avatar ? avatar.url : NotAvatar"
            aspect-ratio="1"
            v-else>
          </v-img>
        </v-avatar>
        <span v-if="$vuetify.display.width > 500">
          {{ user.username }}
        </span>
        <v-icon>arrow_drop_down</v-icon>
      </v-btn>
    </template>
    <v-list class="top_menu__button__list">
      <template v-if="accounts && accounts.has_additional">
        <v-list-item
          class="top_menu__button__list-item"
          :key="`${i}_accountAccounts`"
          v-for="(item, i) in  accounts.accounts"
          @click="$emit('account-change', item.value)"
        >
          <v-list-item-title class="top_menu__button__list-title text-body-1">
            {{ item.text }} <span v-if="item.is_origin">(основной)</span>
          </v-list-item-title>
        </v-list-item>
      </template>
      <v-list-item
        class="top_menu__button__list-item"
        :key="i"
        v-for="(item, i) in actions"
        @click="$emit('action-click', item)"
      >
        <v-list-item-title class="top_menu__button__list-title text-body-1">
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="top_menu__button__list-item" @click="$emit('logout',false, true, false)">
        <v-list-item-title class="top_menu__button__list-title text-body-1">
          Выйти
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import NotAvatar from "@/assets/NotAvatar.png";

export default {
  name: 'UserMenu',
  computed: {
    NotAvatar () {
      return NotAvatar
    }
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    avatar: {
      type: Object
    },
    accounts: {
      type: Object,
      default: () => ({}),
    },
    actions: {
      type: Array,
      default: () => [],
    }
  },
  emits: ['account-change', 'action-click', 'logout'],
}
</script>

<style lang="scss" scoped>

</style>
